/**
 *
 * Names of the items the addins access in the local storage
 */

enum LocalStorageNames {
    addinSession = "session", // Session created by this page outside of geotab
    geotabSessionPrefix = "sTokens_",
    sessionKeyPrefix= "geotabClientCredentials_",
    activeSessionKey= "activeSessionId",
    userUiSettingsPrefix = "userUiSettings_",
}
export default LocalStorageNames
